type Code =
  | 'CodeMismatchException'
  | 'ExpiredCodeException'
  | 'InvalidParameterException'
  | 'TooManyRequestsException'
  | 'LimitExceededException'
  | 'NotAuthorizedException'
  | 'UsernameExistsException'
  | 'UserNotConfirmedException'
  | 'InternalErrorException'
  | 'ResourceNotFoundException';

export default class CognitoError extends Error {
  code?: Code | string;

  constructor(code?: Code | string, message?: string, options?: ErrorOptions) {
    super(message, options);
    this.name = 'CognitoError';
    this.code = code;
  }
}
